import { RequestHelper } from "../Helpers/RequestHelper.js";
import { PmSiteSettings } from "./PmSiteSettings.js";

export class PmDRSApi {
    /**
     * 
     * @param  Object config {production: bool, siteToken: ''}
     * @return {[type]}        [description]
     */
    constructor(config) {
        this.config = config;
        this.pmSiteSettings = new PmSiteSettings(this);
    }

    // getting URLs
    getRootURL() {
        if (this.config.production) {
            return "https://dra.dev.pixelmotiondemo.com/";
        }
        return "http://pm-drs-api.loc/";
    }

    getURL() {
        return this.getRootURL() + "api";
    }

    // methods for offerlogix
    zipCodeFinderInfo(zipcode, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "/offerlogix/zipcodes/" + zipcode,
            {},
            successCallback,
            errorCallback
        );
    }

    /**
     * Including taxes
     * @param  {[type]} requestParams   [description]
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    getOfferlogixPayments(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",

            this.getURL() + "/offerlogix/payments",
            requestParams,
            successCallback,
            errorCallback
        );
    }

    /**
     * no taxes, any vin
     * @param  {[type]} requestParams   [description]
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    getAllCarUsaPayments(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "/allcarusa/payments/",
            requestParams,
            successCallback,
            errorCallback
        );
    }

    /**
     * 
     * @param  {[type]} requestParams   [description]
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    getPrecacheCustomQuotes(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "/lenderDesk/precacheCustomQuotes/" + this.config.siteToken,
            requestParams,
            successCallback,
            errorCallback
        );
    }

    /**
     * no taxes, not any vin
     * @param  {[type]} requestParams   [description]
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    getAllCarUsaCustomQuotes(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "/allcarusa/customQuotes/" + this.config.siteToken,
            requestParams,
            successCallback,
            errorCallback
        );
    }

    /**
     * Same as custom quotes, but with taxes and fees
     * @param  {[type]} requestParams   [description]
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    getAllCarUsaCustomQuotesWithTaxes(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "/allcarusa/customQuotesWithTaxes/" + this.config.siteToken,
            requestParams,
            successCallback,
            errorCallback
        );
    }

    getLenderDeskLenders(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "/lenderDesk/lenders/" + this.config.siteToken,
            requestParams,
            successCallback,
            errorCallback
        );
    }

    /**
     * Same thing as getPayments without taxes
     * @param  {[type]} requestParams   [description]
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    svcQuoteOffer(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",

            this.getURL() + "/offerlogix/svcQuoteOffer",
            requestParams,
            successCallback,
            errorCallback
        );
    }

    /**
     * Same thing as getPayments without taxes
     * @param  {[type]} requestParams   [description]
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    findVehicleGroups(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",

            this.getURL() + "/offerlogix/CSR/findVehicleGroups",
            requestParams,
            successCallback,
            errorCallback
        );
    }

    getOfferlogixAPR(siteToken, vin, offerlogixSource, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "/ratesheets/offerlogix/get/" + siteToken + "/" + vin,
            { source: offerlogixSource },
            successCallback,
            errorCallback
        );
    }

    getPixelmotionAPR(oem, siteToken, vin, successCallback, errorCallback) {
        let route = this.getURL() + "/ratesheets/get/" + oem + "/" + siteToken + "/" + vin;
        console.log(route);
        RequestHelper.ajax("GET", route, {}, successCallback, errorCallback);
    }

    // DOUBLING FUNCTION ON PmSiteSettings
    // getSiteSettings(siteToken, successCallback, errorCallback) {
    //     RequestHelper.ajax("GET", this.getURL() + "/siteSettings/" + siteToken, {}, successCallback, errorCallback);
    // }

    getYears(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/crs/getYears", data, successCallback, errorCallback);
    }

    getMakeNameByYear(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/crs/getMakeNameByYear", data, successCallback, errorCallback);
    }

    getModelByYearAndMakeName(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/crs/getModels", data, successCallback, errorCallback);
    }

    getTrimName(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/crs/getTrimName", data, successCallback, errorCallback);
    }

    getPaymentIntent(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/payment/createIntent/" + this.config.siteToken, data, successCallback, errorCallback);
    }

    saveDrsTrackingActivity(data, successCallback, errorCallback) {
        RequestHelper.ajax("POST", this.getURL() + "/drsTrackingActivity/save/" + this.config.siteToken, data, successCallback, errorCallback);
    }

    saveCustomer(data, successCallback, errorCallback) {
        RequestHelper.ajax("POST", this.getURL() + "/customer/save/", data, successCallback, errorCallback);
    }

    getRatesheetsCache(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/ratesheets/cache", data, successCallback, errorCallback);
    }

    getLenderDeskVinListPayments(siteToken, data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/lenderDesk/vinListPayments/" + siteToken, data, successCallback, errorCallback);
    }

    getPmRatesCustomQuotes(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/pmRates/customQuotes/" + this.config.siteToken, requestParams, successCallback, errorCallback);
    }

    getPmRatesGenericQuote(requestParams, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/pmRates/quote/" + this.config.siteToken, requestParams, successCallback, errorCallback);
    }

    getPmPaymentsBySite(siteToken, data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/pmPayments/" + siteToken, data, successCallback, errorCallback);
    }

    getPmPayments(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/pmPayments", data, successCallback, errorCallback);
    }

    getVehicleByVin(siteToken, vin, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/vehicle/" + siteToken + "/" + vin, {}, successCallback, errorCallback);
    }

    getVehiclesByVins(siteToken, vins, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/vehicles/" + siteToken, { vins: vins }, successCallback, errorCallback);
    }
}
